import React from 'react';

const ORDER = ['red', 'amber', 'green'];

const LABELS = { red: 'Red', amber: 'Amber', green: 'Green' };

const QuestionStatusBadge = ({ color, counts }) => {
  const circles = counts
    ? ORDER.filter((c) => counts[c] > 0).map((c) => ({ color: c, count: counts[c] }))
    : color
      ? [{ color }]
      : [];

  if (circles.length === 0) return null;

  return (
    <span className="question-status">
      <span className="question-status__label">Status:</span>
      {circles.map((circle) => (
        <span
          key={circle.color}
          className={`question-status__circle question-status__circle--${circle.color}`}
          title={
            circle.count === undefined
              ? LABELS[circle.color]
              : `${LABELS[circle.color]}: ${circle.count}`
          }
        >
          {circle.count}
        </span>
      ))}
    </span>
  );
};

export default QuestionStatusBadge;
